import { render, staticRenderFns } from "./biometric-result.vue?vue&type=template&id=430aae77&scoped=true&lang=pug&"
import script from "./biometric-result.vue?vue&type=script&lang=ts&"
export * from "./biometric-result.vue?vue&type=script&lang=ts&"
import style0 from "./biometric-result.vue?vue&type=style&index=0&id=430aae77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430aae77",
  null
  
)

export default component.exports